<template>
  <BaseFetchData :action="fetchData">
    <!-- props
      fetchData, status.loading, status.resolved, status.rejected, rejectReason
    -->
    <template #default="fetchDataProps">
      <div v-if="fetchDataProps.status.resolved" class="max-w-4xl mx-auto space-y-8">
        <BaseCard v-if="$membershipHasPermissionTo('read memberships')">
          <BaseCardHeader>
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h3 class="font-medium text-lg">Members</h3>
              </div>
              <div class="flex-none">
                <AddMemberAction
                  v-if="$membershipHasPermissionTo('create memberships')"
                  :account-id="accountId"
                  :roles="roleOptions"
                  @member-add="fetchData"
                />
              </div>
            </div>
          </BaseCardHeader>
          <BaseCardBody clear-padding class="overflow-hidden">
            <BaseDataTable :data="memberships">
              <template #header>
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-full"
                    >
                      {{ $t('global.name') }}
                    </th>
                    <th
                      scope="col"
                      class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      {{ $t('global.role') }}
                    </th>
                    <th
                      scope="col"
                      class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      {{ $t('global.actions') }}
                    </th>
                  </tr>
                </thead>
              </template>
              <template #default="{ item: membership }">
                <MembershipLine
                  :membership="membership"
                  :ownsAccount="membership.user_id === owner?.id"
                  :role-options="roleOptions"
                  @change="fetchData"
                />
              </template>
            </BaseDataTable>
          </BaseCardBody>
        </BaseCard>

        <BaseCard v-if="$membershipHasPermissionTo('read roles')">
          <BaseCardHeader>
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h3 class="font-medium text-lg">Roles</h3>
              </div>
              <div class="flex-none">
                <CreateRoleAction
                  v-if="$membershipHasPermissionTo('create roles')"
                  :account-id="accountId"
                  @created="fetchData"
                />
              </div>
            </div>
          </BaseCardHeader>
          <BaseCardBody clear-padding class="overflow-hidden">
            <BaseDataTable :data="roles">
              <template #header>
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-full"
                    >
                      {{ $t('global.name') }}
                    </th>
                    <th
                      scope="col"
                      class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      {{ $t('global.actions') }}
                    </th>
                  </tr>
                </thead>
              </template>
              <template #default="{ item: role }">
                <RoleLine :role="role" :ownsAccount="$user.id === owner?.id" @change="fetchData" />
              </template>
            </BaseDataTable>
          </BaseCardBody>
        </BaseCard>
      </div>
    </template>
  </BaseFetchData>
</template>

<script>
import { accountsClient } from '@/api/clients';
import { middleware } from '@/routes/guards';
import AddMemberAction from './components/AddMemberAction.vue';
import CreateRoleAction from './components/CreateRoleAction.vue';
import MembershipLine from './components/MembershipLine.vue';
import RoleLine from './components/RoleLine.vue';

export default {
  components: { AddMemberAction, MembershipLine, RoleLine, CreateRoleAction },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      owner: null,
      roles: [],
      memberships: [],
    };
  },
  computed: {
    roleOptions() {
      return this.roles.map((r) => ({ value: r.id, label: r.name }));
    },
  },
  beforeRouteEnter: middleware('account-permission:read memberships'),
  methods: {
    fetchData() {
      return accountsClient
        .read(this.accountId, {
          include: 'memberships.roles,memberships.user,memberships,roles,owner',
        })
        .then((r) => {
          this.owner = r.data.owner;
          this.roles = r.data.roles;
          this.memberships = r.data.memberships;
        });
    },
  },
};
</script>
